import { Anchor, Text } from '@zillow/constellation-10';

export const ApplicationsTermsOfUse = () => (
  <Text>
    By providing access to representatives, you agree that you and your representatives will comply with our{' '}
    <Anchor target="_blank" href="https://www.zillowgroup.com/terms-of-use/">
      Terms of Use
    </Anchor>{' '}
    and that you are responsible for any use and access of the application, credit report, and background check by you
    and your representative.
  </Text>
);
